import React, { useMemo } from 'react';
import {
  Button,
  IconButton,
  InputAdornment,
  TextField,
  List,
  ListItem,
  Popover,
  Checkbox,
} from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import SearchIcon from '@material-ui/icons/Search';
import ArrowDropDownIcon from '@material-ui/icons/ArrowDropDown';
import CloseIcon from '@mui/icons-material/Close';
import {
  IN_ROOM_DINING_MENU_CATEGORIES,
  IN_ROOM_DINING_MENU_COMBO,
  IN_ROOM_DINING_MENU_ITEMS,
} from '../../../../../constants/InRoomDiningConst';
import MenuLibraryList from './Menu-Library-List';

const useStyles = makeStyles((theme) => ({
  activeButton: {
    color: '#29E67C',
    borderRadius: '26px',
    border: '2px solid #74E287',
    opacity: 1,
    fontWeight: 600,
    fontSize: '1.2em',
  },
  button: {
    borderRadius: '26px',
    fontWeight: 600,
    fontSize: '1.2em',
  },
  input: {
    display: 'none',
  },
}));

const MenuLibrary = (props) => {
  const {
    activeTab,
    search,
    onSearch,
    onChangeCheckbox,
    onClickTabButton,
    menuList,
    handleFilterMenu,
    showFilterList,
    mainAnchorEl,
    handleSelectSubMenuItem,
    getList,
    onDragStart,
    handleSubmit,
  } = props;
  const classes = useStyles();

  const setSearchLabel = () => {
    if (activeTab === IN_ROOM_DINING_MENU_ITEMS) return 'Search Items';
    if (activeTab === IN_ROOM_DINING_MENU_COMBO) return 'Search Combo';
    if (activeTab === IN_ROOM_DINING_MENU_CATEGORIES) return 'Search Categories';
  };
  const filterItems = getList(activeTab) || [];
  const isFilterApplied = filterItems?.some((item) => item?.selected);
  const selectedKeySet = useMemo(() => {
    if (!isFilterApplied) return null;
    const set = new Set();
    for (const f of filterItems) {
      if (!f?.selected) continue;
      const key = f?.id ?? f?.code ?? f?.name;
      if (key != null) set?.add(String(key));
    }
    return set;
  }, [filterItems, isFilterApplied]);
  const visibleList = useMemo(() => {
    let base = Array?.isArray(menuList) ? menuList : [];
    if (selectedKeySet && selectedKeySet?.size > 0) {
      base = base?.filter((item) => {
        const key = item?.id ?? item?.code ?? item?.name;
        return key != null && selectedKeySet?.has(String(key));
      });
    }
    const q = (search || '')?.trim()?.toLowerCase();
    if (!q) return base;
    const hits = base?.filter((item) => {
      const haystack = [item?.name, item?.code, item?.description, item?.categoryName]
        ?.filter(Boolean)
        ?.map((s) => String(s)?.toLowerCase())
        ?.join(' ');
      return haystack?.includes(q);
    });
    return hits;
  }, [menuList, selectedKeySet, search]);

  return (
    <div className='col-md-4'>
      <div className='card shadow p-3'>
        <div className='row mb-1'>
          <div className='col-md-6'>Library</div>
          <div className='col-md-6 ird-menu-filter-chip'>
            <Button
              variant={isFilterApplied ? 'contained' : 'outlined'}
              size='small'
              endIcon={showFilterList ? <ArrowDropDownIcon /> : <ArrowDropDownIcon />}
              onClick={(e) => handleFilterMenu(e, showFilterList)}
              className='me-5'
              style={isFilterApplied ? { backgroundColor: '#CFF8E0' } : {}}
            >
              Filter
            </Button>
            <Popover
              id='main-menu'
              open={showFilterList}
              anchorEl={mainAnchorEl}
              onClose={handleFilterMenu}
              anchorOrigin={{
                vertical: 'bottom',
                horizontal: 'center',
              }}
              transformOrigin={{
                vertical: 'top',
                horizontal: 'center',
              }}
            >
              <div className='filter-menu'>
                <div className='filter-menu-list'>
                  <List component='nav' aria-label='main user menu'>
                    {getList(activeTab) &&
                      getList(activeTab).map((menuItem, key) => (
                        <ListItem key={key}>
                          <div>
                            <Checkbox
                              onClick={(e) => {
                                handleSelectSubMenuItem(menuItem, e);
                              }}
                              checked={menuItem.selected}
                            ></Checkbox>
                            {menuItem.name}
                          </div>
                        </ListItem>
                      ))}
                  </List>
                </div>
              </div>
            </Popover>
          </div>
        </div>
        <div className='row'>
          <div className='col-md-3'>
            <Button
              size='small'
              variant={activeTab === IN_ROOM_DINING_MENU_ITEMS ? 'outlined' : 'text'}
              className={
                activeTab === IN_ROOM_DINING_MENU_ITEMS ? classes.activeButton : classes.button
              }
              onClick={() => onClickTabButton(IN_ROOM_DINING_MENU_ITEMS)}
            >
              {IN_ROOM_DINING_MENU_ITEMS}
            </Button>
          </div>
          <div className='col-md-3'>
            <Button
              size='small'
              variant={activeTab === IN_ROOM_DINING_MENU_COMBO ? 'outlined' : 'text'}
              className={
                activeTab === IN_ROOM_DINING_MENU_COMBO ? classes.activeButton : classes.button
              }
              onClick={() => onClickTabButton(IN_ROOM_DINING_MENU_COMBO)}
            >
              {IN_ROOM_DINING_MENU_COMBO}
            </Button>
          </div>
          <div className='col-md-3'>
            <Button
              size='small'
              variant={activeTab === IN_ROOM_DINING_MENU_CATEGORIES ? 'outlined' : 'text'}
              className={
                activeTab === IN_ROOM_DINING_MENU_CATEGORIES ? classes.activeButton : classes.button
              }
              onClick={() => onClickTabButton(IN_ROOM_DINING_MENU_CATEGORIES)}
            >
              {IN_ROOM_DINING_MENU_CATEGORIES}
            </Button>
          </div>
        </div>
        <div className='row'>
          <div className='col-md-12'>
            <TextField
              className='w-100'
              value={search}
              onChange={(e) => onSearch(e.target.value)}
              label={setSearchLabel()}
              InputProps={{
                endAdornment: (
                  <InputAdornment position='end'>
                    <IconButton>
                      <SearchIcon />
                    </IconButton>
                  </InputAdornment>
                ),
              }}
            />
          </div>
        </div>
        <MenuLibraryList
          listData={visibleList}
          onChangeCheckbox={onChangeCheckbox}
          listNameKey='name'
          onDragStart={onDragStart}
        />
      </div>
      <div className='my-3 d-flex justify-content-end'>
        <Button
          onClick={() => handleSubmit()}
          variant='contained'
          color='primary'
          className='me-3'
          size='large'
        >
          Save & Publish
        </Button>
      </div>
    </div>
  );
};

export default MenuLibrary;
